export default __webpack_public_path__ + "static/media/hamburguer-background.6ca64fce.png";